import { z } from 'zod';
import {
  creditResolutionMethodSchema,
  exchangeMethodSchema,
} from '~/utils/schemas';

export const returnSummarySearchParams = {
  exchangeMethod: 'exchangeMethod',
  creditMethod: 'creditMethod',
} as const;

export function getReturnSummaryParams(requestUrl: Request['url']) {
  const url = new URL(requestUrl);
  const params = Object.fromEntries(url.searchParams.entries());
  return z
    .object({
      [returnSummarySearchParams.creditMethod]:
        creditResolutionMethodSchema.optional(),
      [returnSummarySearchParams.exchangeMethod]:
        exchangeMethodSchema.optional(),
    })
    .parse(params);
}
